module.exports = __webpack_public_path__ + "img/sunburst.0838324a.affbe241.svg";